import CMS from "./cms.api";
import Project from "./project.api";
import Users from "./talent.api";
import Company from "./company.api";
import Setting from "./setting.api";
import Core from "./core.api";
import Echarts from "./echarts.api";
import Login from "./login.api";
import User from "./user.api";
import Area from "./area.api";
import Comment from "./comment.api";
import Global from "./global.api";
import Collection from "./collection.api";
import Message from "./message.api";
import Reminds from "./reminds.api";
import Form from "./form.api";
export default {
  Reminds,
  CMS,
  Project,
  Users,
  Company,
  Setting,
  Core,
  Echarts,
  Login,
  User,
  Area,
  Comment,
  Global,
  Collection,
  Message,
  Form
};
